import { PARCELLING_TYPE_OPTIONS } from '../../constants/maintenance.constants';
import type { MaintenanceParcellingType } from '../../types';
import styles from './ParcellingTypeSelector.module.css';

export interface ParcellingTypeSelectorProps {
	value: MaintenanceParcellingType | '';
	onChange: (value: MaintenanceParcellingType) => void;
	disabled?: boolean;
	hasError?: boolean;
}

export const ParcellingTypeSelector = ({
	value,
	onChange,
	disabled,
	hasError,
}: ParcellingTypeSelectorProps) => (
	<div className={styles.group} role="radiogroup" aria-label="Tipo de parcelamento">
		{PARCELLING_TYPE_OPTIONS.map((option) => {
			const isSelected = value === option.value;
			return (
				<button
					key={option.value}
					type="button"
					role="radio"
					aria-checked={isSelected}
					className={`${styles.option} ${isSelected ? styles.selected : ''} ${hasError ? styles.error : ''}`}
					onClick={() => onChange(option.value)}
					disabled={disabled}
				>
					<span className={styles.dot} />
					<span className={styles.label}>{option.label}</span>
				</button>
			);
		})}
	</div>
);
